module.exports = __webpack_public_path__ + "static/media/preview_sections.9cb9c5ee.svg";